// extracted by mini-css-extract-plugin
module.exports = {"window":"CancelParticipationModal_window__5nnPZ","windowHeader":"CancelParticipationModal_windowHeader__3jxtf","windowSubheader":"CancelParticipationModal_windowSubheader__1c5xM"};